import { useRouter } from 'next/router'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { INTEGRATION_QUERIES } from 'routes/constants'
import NavLink from 'ui-kit/actions/link/NavLink'
import clsx from 'clsx'
import classes from './IntegrationPageNavigation.module.scss'

type PageType = {
  title: string
  href: string
  filterFn?: (integration: IntegrationType) => boolean
}

const pages: PageType[] = [
  { title: 'Overview', href: '' },
  {
    title: 'Getting Started',
    href: INTEGRATION_QUERIES.GETTING_STARTED,
    filterFn: (integration: IntegrationType) => !!integration?.hasReadme,
  },
  // { title: 'Authentication', href: 'authentication' },
  // { title: 'API', href: 'api' },
  {
    title: 'Data Collections',
    href: INTEGRATION_QUERIES.DATA_COLLECTIONS,
    filterFn: (integration: IntegrationType) =>
      !!integration?.data_collections_amount,
  },
  {
    title: 'Operations',
    href: INTEGRATION_QUERIES.OPERATIONS,
    filterFn: (integration: IntegrationType) =>
      !!integration?.operations_amount,
  },
  {
    title: 'Scenarios',
    href: INTEGRATION_QUERIES.SCENARIOS,
    filterFn: (integration: IntegrationType) => !!integration?.scenarios_amount,
  },
  // { title: 'Events', href: 'events' },
  // { title: 'Integration Scenarios', href: 'integration-scenarios' },
]

export function IntegrationPageNavigation({ integration }) {
  const { asPath } = useRouter()

  const sections = pages.filter((page) => page?.filterFn?.(integration) ?? true)

  if (sections.length < 2) {
    return null
  }

  return (
    <nav className={classes.navigation}>
      {sections.map((page) => (
        <NavLink
          key={page.href}
          href={getSubsectionLink(integration, page.href)}
          className={clsx(
            classes.link,
            isActiveRoute(integration, asPath, page.href) &&
              classes.link__active,
          )}
        >
          {page.title}
        </NavLink>
      ))}
    </nav>
  )
}

function getSubsectionLink(integration: IntegrationType, path: string) {
  return `/integrations/${integration.key}${path ? `/${path}` : ''}`
}

function isActiveRoute(
  integration: IntegrationType,
  asPath: string,
  href: string,
) {
  if (!href) {
    return asPath === `/integrations/${integration.key}`
  }

  return asPath.startsWith(`/integrations/${integration.key}/${href}`)
}
